import {
    addSaveForLaterWishlist,
} from "@NA/Services/ADISaveForLater";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";


interface AddParameter {
    name: string;
    description: string;
    onSuccess?: (result: any) => void;
    onError?: (error: string) => void;
}

interface AddApiParameter {
    name: string;
    description: string;
}

type HandlerType = CustomApiHandler<AddParameter, AddApiParameter>;


export const AddSaveForLaterWishList: HandlerType = async (props: any) => {
    props.apiResult = await addSaveForLaterWishlist(props.parameter);
};

export const loadWishListsSaveForLater: HandlerType = async (props: any) => {
    await props.dispatch(loadWishLists({}));

    if (props.parameter && typeof props.parameter.onSuccess === "function") {
        await props.parameter.onSuccess(props.apiResult as any);
    } else {
        console.warn("onSuccess is not a function or is undefined.");
    }
};

export const chain = [AddSaveForLaterWishList, loadWishListsSaveForLater];

const addSaveForLater = createHandlerChainRunner(chain, "AddToSaveForLater");
export default addSaveForLater;
